export default __webpack_public_path__ + "static/media/register.831c9eb5.jpg";